import React from 'react';

export const Document = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 44 42">
      <path
        stroke="#72DCEB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M1 1h17.063v5.688H1V1z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#72DCEB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M4.792 6.688h17.062v5.687H4.791V6.687zm-1.896 5.687h17.063v5.688H2.896v-5.688z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#72DCEB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M1 18.063h17.063v5.687H1v-5.688zm1.896 5.687h17.063v5.688H2.896V23.75z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#72DCEB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M1 29.438h17.063v5.687H1v-5.688zm1.896 5.687h17.063v5.688H2.896v-5.688zM23.75 23.75h17.063v5.688H23.75V23.75z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#72DCEB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M25.646 29.438h17.063v5.687H25.646v-5.688zm-1.896 5.687h17.063v5.688H23.75v-5.688z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
